import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-lot-body-defects-info',
  templateUrl: './lot-body-defects-info.component.html',
  styleUrls: ['./lot-body-defects-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotBodyDefectsInfoComponent {
  @Input() active = false;
}
